import React from "react";
import SC from "./style";

const Label = ({ label, children, align = "center" }) => {
  return (
    <>
      <SC.Container align={align}>
        <SC.Label>{label}</SC.Label>
        <SC.Children>{children}</SC.Children>
      </SC.Container>
    </>
  );
};

export default Label;
